export default "__VITE_ASSET__DsZbqryG__"